import React from 'react';
import Pin from 'Modules/Shared/icons/pin';
import ClariTheme from 'Utils/theme/ClariTheme';

const PinIcon = () => {
  return (
    <Pin width={24} height={24} fill={ClariTheme.palette.text.accentGray} />
  );
};

export default PinIcon;
